// extracted by mini-css-extract-plugin
module.exports = {"container":"history-item_container__HuxRj","detail":"history-item_detail__3u5bI","chart-img-div":"history-item_chart-img-div__oxqKc"};